import { of } from 'rxjs';

import { map, withLatestFrom, switchMap, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { CAAction } from '../actions';
import * as selectors from '../reducers/index';
import { MarketManagementCategories as actions } from './market-management-category.actions';
import { MarketManagementService } from '@careapp-group/ng-sdk-v2-new';

@Injectable()
export class MarketManagementEffects {
  createMarketCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.RequestCreateAction),
      withLatestFrom(this.store.select(selectors.getSelectedId(selectors.TENANTS))),
      switchMap(([action, tenantId]) =>
        this.marketManagementApi
          .createMarketCategory({
            createMarketCategoryDto: {
              description: action.payload.description,
              name: action.payload.name,
              tenantId,
              featuredImageId: action.payload.featuredImageId,
            },
          })
          .pipe(
            map((response) => actions.ResponseSuccessCreateAction({ payload: response })),
            catchError((error) => of(actions.ResponseFailCreateAction({ error })))
          )
      )
    )
  );

  getMarketCategories$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.RequestRetrieveAllAction),
      withLatestFrom(this.store.select(selectors.getSelectedId(selectors.TENANTS))),
      switchMap(([action, tenantId]) => {
        return this.marketManagementApi.listMarketCategories({ tenantId }).pipe(
          map((response) => actions.ResponseSuccessRetrieveAllAction({ payload: response })),
          catchError((error) => of(actions.ResponseFailRetrieveAllAction({ error })))
        );
      })
    )
  );

  constructor(
    private store: Store<any>,
    private actions$: Actions<CAAction>,
    private marketManagementApi: MarketManagementService
  ) {}
}
